import { RefObject, useCallback, useEffect, useState } from "react";

// ожидает реф на элемент, который нужно сделать полноэкранным
const useFullscreen = <T extends HTMLElement | null>(elementRef: RefObject<T>) => {
	const [isFullscreen, setIsFullscreen] = useState(false);

	const toggleFullscreen = useCallback(async () => {
		if (!elementRef.current) return;

		if (!document.fullscreenElement) {
			await elementRef.current.requestFullscreen();
			setIsFullscreen(true);
		} else {
			await document.exitFullscreen();
			setIsFullscreen(false);
		}
	}, [elementRef]);

	useEffect(() => {
		const handleFullscreenChange = () => {
			setIsFullscreen(!!document.fullscreenElement);
		};

		document.addEventListener("fullscreenchange", handleFullscreenChange);
		return () => {
			document.removeEventListener("fullscreenchange", handleFullscreenChange);
		};
	}, []);

	return { isFullscreen, toggleFullscreen };
};

export default useFullscreen;
